import * as React from 'react';
import * as Styled from './breadcrumbsBlockStyle';
import { Col, Row } from 'react-bootstrap';
import iconPrint from './../../images/icon-print.png';
import { CommonBreadCrumb, MenuType } from '../../utils/utils';
import isExternalUrl, {
  addTrailingSlash,
  isExternalUrlhref,
} from '../../utils';

const BreadcrumbsBlock = (props) => {
  const pathArray = props?.path?.split('/');
  const result = pathArray.filter(checkNull);
  const isCommercial = result[0] === 'commercial-industrial';

  function checkNull(path) {
    return path !== '';
  }
  const isBrowser = typeof window !== 'undefined';
  const printPage = () => {
    if (isBrowser) {
      window.print();
    }
  };

  return (
    <>
      <Styled.HeaderContainer fluid>
        <Styled.InnerContainer>
          <Styled.HeaderRow>
            <Styled.HeaderCol
              $isCommercial={isCommercial}
              lg={3}
              className="d-none d-lg-block w-100"
            >
              <Row className="g-0">
                <Col lg>
                  <Styled.HeaderText $isCommercial={isCommercial}>
                    {result[0] === MenuType[0].path
                      ? MenuType[0].name
                      : result[0]}
                  </Styled.HeaderText>
                </Col>
              </Row>
            </Styled.HeaderCol>
            <Styled.ParaCol xs={12} md>
              <Styled.ParaText>
                <Styled.AnchorText
                  to={addTrailingSlash(process.env.GATSBY_DOMAIN_URL)}
                >
                  Home
                </Styled.AnchorText>
                {result?.map((path, index) => {
                  for (let key in CommonBreadCrumb) {
                    if (path === key) {
                      path = CommonBreadCrumb[key];
                    }
                  }
                  return (
                    <React.Fragment key={index}>
                      /
                      {index !== result.length - 1 ? (
                        <Styled.AnchorText2
                          href={
                            isExternalUrlhref(
                              '/' + result?.slice(0, index + 1).join('/') + '/ '
                            )
                              ? '/' +
                                result?.slice(0, index + 1).join('/') +
                                '/ '
                              : process.env.GATSBY_DOMAIN_URL +
                                ('/' +
                                  result?.slice(0, index + 1).join('/') +
                                  '/ ')
                          }
                          key={index}
                          target={
                            isExternalUrl(
                              '/' + result?.slice(0, index + 1).join('/') + '/ '
                            )
                              ? '_blank'
                              : '_self'
                          }
                        >
                          {path?.replaceAll('-', ' ')}
                        </Styled.AnchorText2>
                      ) : (
                        <Styled.PathText>
                          {path?.replaceAll('-', ' ')}
                        </Styled.PathText>
                      )}
                    </React.Fragment>
                  );
                })}
              </Styled.ParaText>
            </Styled.ParaCol>
            <Styled.PrinterLogoCol xs={12} md={1} className="d-none d-md-block">
              <a onClick={() => printPage()}>
                <Styled.LogoImage
                  src={iconPrint}
                  alt="Printer Logo"
                  title="Print Page"
                />
              </a>
            </Styled.PrinterLogoCol>
          </Styled.HeaderRow>
        </Styled.InnerContainer>
      </Styled.HeaderContainer>
    </>
  );
};

export default BreadcrumbsBlock;
